import { render } from "./xtkReadTrk.vue?vue&type=template&id=627baf1e&scoped=true"
import script from "./xtkReadTrk.vue?vue&type=script&lang=js"
export * from "./xtkReadTrk.vue?vue&type=script&lang=js"

import "./xtkReadTrk.vue?vue&type=style&index=0&id=627baf1e&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627baf1e"]])

export default __exports__